import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataImportDialogDataModel, ImportEvent } from './data-import-dialog-data.model';
import { DataImportService, FileDataImportUploadObject } from '../../../_core/state/dataImport/dataImport.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { SessionService } from '../../../_core/state/session/session.service';
import { SessionQuery } from '../../../_core/state/session';
import { Type } from '../../../../../../api/src/dataimport/dataimport.entity';
import { GlobalService } from '../../../_core/state/global';

@Component({
	selector: 'app-data-import-dialog',
	templateUrl: './data-import-dialog.component.html',
	styleUrls: ['./data-import-dialog.component.scss']
})
export class DataImportDialogComponent implements OnInit {
	public selectedFiles?: FileDataImportUploadObject[] = [];
	private siteId: string = environment.organizationId;
	public user: any;
	public submitted: boolean = false;
	toastController: any;
	public errorMessage: string = '';

	constructor(
		public dialogRef: MatDialogRef<DataImportDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public readonly dialogSettings: DataImportDialogDataModel,
		private readonly dataImportService: DataImportService,
		private readonly sessionService: SessionService,
		private readonly sessionQuery: SessionQuery,
		private readonly globalService: GlobalService
	) {}

	async ngOnInit() {
		this.sessionService.getUserStatus(this.sessionQuery.getToken()).subscribe(response => {
			this.user = response.profile;
		});
	}

	// public selectFile(files: FileList) {
	// 	if (files?.length === 0) {
	// 		return;
	// 	}

	// 	this.selectedFiles = Array.from(files);

	// 	return false;
	// }

	public async selectFile(event: any) {
		this.selectedFiles = [];
		for (let index = 0; index < event.length; index++) {
			const f: File = event[index];
			const element: FileDataImportUploadObject = {
				title: f.name,
				type: Type.BusinessVerificationList,
				uploaded: false,
				uploading: false,
				file: this.dialogSettings.onCheckFile ? await this.dialogSettings.onCheckFile(f) : f
			};
			if(element.file){
				this.selectedFiles.push(element);
			}
			
		}

		return false;
	}

	public removeFile(index: number): void {
		if (!this.selectedFiles?.length) {
			return;
		}
		this.selectedFiles.splice(index, 1);
	}

	public async import(file: FileDataImportUploadObject, businessId?: string): Promise<any> {
		if (this.selectedFiles) {
			this.selectedFiles[0].uploading = true;
		}
		console.log('this.siteId', this.siteId)
		this.dataImportService.upload(file, this.siteId, this.dialogSettings.event, this.dialogSettings.businessId).subscribe(
			event => {
				if (event.type === HttpEventType.UploadProgress) {
					// TODO
				} else if (event instanceof HttpResponse) {
					// file.id = event?.body?.['id'];
					this.selectedFiles[0].uploading = false;
					this.selectedFiles[0].uploaded = true;

					this.dialogRef.close(event.body);

					return event;
				}
			},
			async err => {
				console.log('upload err', err);
				// return err;
				// file.uploaded = false;
				this.selectedFiles[0].uploading = false;
				this.errorMessage = err.error.message;

				this.globalService.triggerErrorMessage(undefined, err.error.message);
				this.submitted = false;
			}
		);
	}

	async submit() {
		this.submitted = true;

		if (this.dialogSettings.event === ImportEvent.Other) {
			this.dialogRef.close(this.selectedFiles);
			this.submitted = false;
			return;
		}

		let importDone = await this.import(this.selectedFiles[0]);
		/*console.log('importDone', importDone)
		if (importDone) {
			console.log('importDone', importDone);
			this.dialogRef.close(this.selectedFiles);
			this.submitted = false;
		}*/
	}
}
